import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { cn } from "../../../../../helpers/cn";
import { Stack, StackProps } from "@mui/material";

type ListingModalOptionWrapperProps = StackProps;

export const ListingModalOptionWrapper = ({
  className,
  children,
  style,
  ...props
}: ListingModalOptionWrapperProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Stack
      style={{
        borderBottom: "1px solid",
        borderColor: colors.outline.outlineVariant,
        padding: "16px 0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "start",
        ...style,
      }}
      className={cn("space-y-2", className)}
      {...props}
    >
      {children}
    </Stack>
  );
};
